import { useEffect, useRef, useState } from "react";
import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  root: {
    opacity: 0,
    transform: "translateY(28px)",
    willChange: "opacity, transform",
    "@media (prefers-reduced-motion: reduce)": {
      opacity: 1,
      transform: "none",
      transition: "none",
    },
  },
  visible: {
    opacity: 1,
    transform: "translateY(0)",
    transition: "opacity 0.75s cubic-bezier(0.22, 1, 0.36, 1), transform 0.75s cubic-bezier(0.22, 1, 0.36, 1)",
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none",
    },
  },
}));

export default function Reveal({ children, delay = 0, className, as: Component = "div", ...props }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const { classes, cx } = useStyles();

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -32px 0px" }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <Component
      ref={ref}
      className={cx(classes.root, visible && classes.visible, className)}
      style={{ transitionDelay: `${delay}ms`, ...props.style }}
      {...props}
    >
      {children}
    </Component>
  );
}
